module.exports = __webpack_public_path__ + "static/media/ic-QUO.d1670256.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-QUO.svg
// module id = 1284
// module chunks = 17